import React from 'react';
import Interactions from '../components/Interaction/Interactions';


const Interaction = () => {
    return ( <Interactions/> );
}
 
export default Interaction;